import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import styles from './ProductCard.module.css';

const ProductCard = ({ product }) => {
  const { addToCart, fetchCartItems, cartItems, updateQuantity, removeFromCart } = useCart();
  const [email, setEmail] = useState('');
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [quantity, setQuantity] = useState(0);

  // Recuperar email del localStorage si existe
  useEffect(() => {
    const savedEmail = localStorage.getItem('guest_email');
    if (savedEmail) {
      setEmail(savedEmail);
    }
  }, []);

  // Actualiza la cantidad si el producto está en el carrito
  useEffect(() => {
    const cartItem = cartItems?.find(
      (item) => item.id === product.id
    );
    setQuantity(cartItem ? cartItem.quantity : 0);
  }, [cartItems, product.id]);

  const handleAddToCart = async (e) => {
    e.preventDefault();
    if (!email) {
      setShowEmailInput(true);
      return;
    }
    localStorage.setItem('guest_email', email);
    await addToCart(product, 1, email);
    await fetchCartItems();
    setShowEmailInput(false);
  };

  const handleIncrease = async (e) => {
    e.preventDefault();
    await updateQuantity(product.id, quantity + 1, email);
    await fetchCartItems();
  };

  const handleDecrease = async (e) => {
    e.preventDefault();
    if (quantity > 1) {
      await updateQuantity(product.id, quantity - 1, email);
      await fetchCartItems();
    } else {
      await removeFromCart(product.id, email);
      await fetchCartItems();
    }
  };

  const validateEmail = (email) => {
    return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  };

  return (
    <Link to={`/product/${product.slug}`} className={styles.card}>
      <div className={styles.imageContainer}>
        <img 
          src={product.primary_image} 
          alt={product.name} 
          className={styles.image}
        />
        {product.stockQuantity === 0 && (
          <div className={styles.outOfStock}>Agotado</div>
        )}
      </div>

      <div className={styles.content}>
        <h3 className={styles.name}>{product.name}</h3>
        
        <div className={styles.details}>
          <div className={styles.priceContainer}>
            <span className={styles.price}>${product.price.toFixed(2)}</span>
            {product.originalPrice && (
              <span className={styles.originalPrice}>
                ${product.originalPrice.toFixed(2)}
              </span>
            )}
          </div>

          <div className={styles.badges}>
            {product.isPrime && (
              <span className={styles.prime}>Prime</span>
            )}
            {product.isFeatured && (
              <span className={styles.featured}>Destacado</span>
            )}
          </div>
        </div>

        {/*<div className={styles.rating}>
          <div className={styles.stars}>
            {'★'.repeat(Math.floor(product.avgRating || 0))}
            {'☆'.repeat(5 - Math.floor(product.avgRating || 0))}
          </div>
          <span className={styles.reviews}>
            ({product.reviewCount || 0})
          </span>
        </div>*/}

        {showEmailInput ? (
          <div className={styles.emailInputContainer} onClick={(e) => e.preventDefault()}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ingresa tu email"
              className={styles.emailInput}
            />
            <button 
              className={styles.addToCart}
              onClick={handleAddToCart}
              disabled={!validateEmail(email)}
            >
              Confirmar
            </button>
          </div>
        ) : quantity > 0 ? (
          <div className={styles.cartQuantityControls}>
            <button
              className={styles.decreaseBtn}
              onClick={handleDecrease}
              disabled={quantity === 0}
            >−</button>
            <span className={styles.quantity}>{quantity}</span>
            <button
              className={styles.increaseBtn}
              onClick={handleIncrease}
              disabled={quantity >= product.stockQuantity}
            >+</button>
          </div>
        ) : (
          <button 
            className={styles.addToCart}
            onClick={handleAddToCart}
            disabled={product.stockQuantity === 0}
          >
            Agregar al carrito
          </button>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;